import { Stack, Typography, Box } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTheme } from '@mui/material/styles';

export default function SSCCOfflineCard() {
  const theme = useTheme();

  return (
    <Stack
      spacing={3}
      alignItems="center"
      justifyContent="center"
      sx={{
        padding: '3em 2em',
        maxWidth: '600px',
        margin: '0 auto',
        minHeight: '70vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%'
      }}>
      {/* Main Icon */}
      <Box
        sx={{
          animation: 'pulse 2s infinite',
          '@keyframes pulse': {
            '0%': { opacity: 1 },
            '50%': { opacity: 0.3 },
            '100%': { opacity: 1 }
          }
        }}>
        <WifiOffIcon
          sx={{
            fontSize: 48,
            color: theme.palette.text.secondary,
            opacity: 0.7
          }}
        />
      </Box>

      {/* Main Message */}
      <Stack spacing={1} alignItems="center" textAlign="center">
        <Typography
          variant="h6"
          fontWeight="600"
          sx={{
            color: theme.palette.text.primary,
            fontSize: '1.25rem'
          }}>
          No Connection
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: '0.95rem',
            lineHeight: 1.5
          }}>
          FTL requires internet connection and no features can be used offline
        </Typography>
      </Stack>
    </Stack>
  );
}
